import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Col, Form, Row, Tag } from "antd";
import { useMemo } from "react";
import { EServiceTemplateGoogleConsentModeTypes, EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { getGoogleConsentModeTypeTranslation } from "../../../../../../util/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateGcmConsentTypes() {
    const { t } = useTranslation();
    const typeTranslations = useMemo(()=>{
        const translations = {};
        for (const type of Object.values(EServiceTemplateGoogleConsentModeTypes)){
            translations[type] = getGoogleConsentModeTypeTranslation(type, t);
        }
        return translations;
    }, [
        t
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.GoogleConsentModeConsentTypes,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.GoogleConsentModeConsentTypes, t),
            extra: t("You must obtain consent according to the Google Consent Mode based on so-called consent types. For this service, you should request all necessary consent types in order to be able to collect as much data as possible."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                const extendedConsentTypes = extended?.googleConsentModeConsentTypes || [];
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                        extendsFieldName: ServiceTemplateField.GoogleConsentModeConsentTypes,
                        disableStrategies: getDisableStrategies(),
                        onKeepContent: extended && /*#__PURE__*/ _jsx(Checkbox.Group, {
                            style: {
                                width: "100%"
                            },
                            defaultValue: extendedConsentTypes,
                            children: /*#__PURE__*/ _jsx(Row, {
                                children: Object.values(EServiceTemplateGoogleConsentModeTypes).map((val)=>/*#__PURE__*/ _jsx(Col, {
                                        span: 24,
                                        children: /*#__PURE__*/ _jsxs(Checkbox, {
                                            disabled: true,
                                            value: val,
                                            style: {
                                                marginBottom: "3px"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(Tag, {
                                                    children: /*#__PURE__*/ _jsx("code", {
                                                        children: val
                                                    })
                                                }),
                                                typeTranslations[val]
                                            ]
                                        }, val)
                                    }, `ext-${val}`))
                            })
                        }),
                        children: /*#__PURE__*/ _jsx(Form.Item, {
                            name: ServiceTemplateField.GoogleConsentModeConsentTypes,
                            children: /*#__PURE__*/ _jsx(Checkbox.Group, {
                                style: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ _jsx(Row, {
                                    children: Object.values(EServiceTemplateGoogleConsentModeTypes).map((val)=>/*#__PURE__*/ _jsx(Col, {
                                            span: 24,
                                            children: /*#__PURE__*/ _jsxs(Checkbox, {
                                                value: val,
                                                style: {
                                                    marginBottom: "3px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx(Tag, {
                                                        children: /*#__PURE__*/ _jsx("code", {
                                                            children: val
                                                        })
                                                    }),
                                                    typeTranslations[val]
                                                ]
                                            }, val)
                                        }, val))
                                })
                            })
                        })
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateGcmConsentTypes };
